// extracted by mini-css-extract-plugin
var _1 = "PRxJdy0KdJFEozit4DEN";
var _2 = "VYDHSC6PpKdFE3oagzxQ";
var _3 = "bInxOBheNs664QNVbGMl";
var _4 = "zO7pqyzPwoM8abgCKJb5";
export { _1 as "scaleFactorGeneral", _2 as "scaleFactorLong", _3 as "scaleFactorTotalCollapsed", _4 as "scaleFactorTotalExpanded" }
